import React from 'react';
import { PublicLayout } from '../components/layout/Layout';
import { LoginForm } from '../components/auth/LoginForm';

// Force HMR for this component
if (import.meta.hot) {
  import.meta.hot.accept('../components/auth/LoginForm', () => {
    import.meta.hot?.invalidate()
  })
}

const Login = ({ errors, routes }) => {
  return (
    <PublicLayout>
      <LoginForm errors={errors} routes={routes} />
    </PublicLayout>
  );
}; // test hmr

export default Login;
